import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import { t } from '../../common/i18n/index.js';

export const VaihtoetuFaq = () => {
  const faq = [
    {
      id: 'WZF5',
      question: t.WZF5('What can I use the Elisa Vaihtoetu (Trade-in) for Business credit for?'),
      answer: t.KHWC(
        'You can use the credit, for example, for monthly fees for subscriptions and services or for purchasing new devices. The credit is applied to your company’s billing agreement and is not paid out in cash.'
      ),
    },
    {
      id: 'YC2H',
      question: t.YC2H(
        'When is the trade-in credit applied to my company’s billing agreement? How long does the process take?'
      ),
      answer: t.T88E(
        'The trade-in credit is applied after the device has passed the condition inspection. You will receive confirmation of the inspection by email. If the estimated value changes, you will receive a new offer by email, which you can accept or decline. If you decline the offer, the device will be returned to you. \nThe entire process typically takes 2–4 weeks from start to finish.'
      ),
    },
    {
      id: 'X3A5',
      question: t.X3A5('Which devices are eligible for trade-in?'),
      answer: t.ZG2D(
        'We offer trade-in credit for phones, tablets, and smartwatches. You can also receive credit for older devices, even if they are nearing the end of their lifecycle.'
      ),
    },
    {
      id: 'N5AF',
      question: t.N5AF('Can I get credit for a scratched or faulty device?'),
      answer: t.JMGK(
        'Yes. The final trade-in value is determined based on the device’s condition. The better the condition, the higher the value, but even faulty devices may still have value.'
      ),
    },
    {
      id: 'AAAN',
      question: t.AAAN('Can I return multiple devices at the same time?'),
      answer: t.FO3J(
        'Yes. However, you must complete a separate price estimate form for each device so that each device receives its own trade-in order and shipping package.\nWe will then combine the credits and transfer the total amount to your company’s billing agreement.'
      ),
    },
    {
      id: 'YHST',
      question: t.YHST('What happens to the old devices?'),
      answer: t.PBQH(
        'All devices go through a secure data handling process where all stored data is reliably and securely erased.\nDevices in good condition are refurbished and resold through our recycling partners. Devices at the end of their lifecycle are dismantled, and the valuable raw materials they contain are recycled for reuse. '
      ),
    },
  ];

  return (
    faq && (
      <div className="of-vaihtoetu">
        <h2 className={`${dsClass.H2} ${dsClass.TEXT_ALIGN_CENTER}`}>{t.IFQ5('Frequently asked questions')}</h2>
        <CL.Accordion openMultiple={true}>
          {faq.map(item => (
            <CL.AccordionItem key={item.id} heading={item.question}>
              <div className={dsClass.MARGIN_HORIZONTAL_3}>{item.answer}</div>
            </CL.AccordionItem>
          ))}
        </CL.Accordion>
      </div>
    )
  );
};
